import React from "react";
import { Button, Col, Container, Row } from "react-bootstrap";
import { Link } from "react-router-dom";
import useAllProduct from "../../../../hooks/useAllProduct";
import SingleProduct from "./SingleProduct";

const ProductSection = () => {
  const [allProduct, setAllProduct] = useAllProduct();
  if (allProduct.length > 6) {
    const newAllProduct = allProduct.slice(0, 6);
    setAllProduct(newAllProduct);
  }
  return (
    <div className="product-section">
      <Container>
        <div className="farmer-title-text">
          <h5 className="text-success">Our Featured Products</h5>
          <h2>Choice Best Product For Your Business</h2>
          <Col md={{ span: 8, offset: 2 }}>
            <p>
              The most important thing you can do before deciding what to sell
              is to think. And the more you think about a product or service
              before you bring it to market, the better your decisions will be.{" "}
              <strong>Choice</strong> is now yours!!{" "}
            </p>
          </Col>
        </div>

        <Row className="pt-5">
          {allProduct.map((product) => (
            <Col key={product?._id} md="3" className="pb-4">
              <SingleProduct info={product}></SingleProduct>
            </Col>
          ))}
        </Row>
        <Row>
          <Col className="pb-5 text-center">
            <Link to={"/all-products"} className="btn btn-success">
              {" "}
              View All Products →{" "}
            </Link>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default ProductSection;
